import { AddThin } from '@shared/assets';
import { IconButton } from '@shared/ui';

interface Props {
  handler?: () => void;
  disabled?: boolean;
  variant?: 'dark' | 'white';
}

export const ButtonAdd = ({ handler, disabled = false, variant = 'white' }: Props): JSX.Element => (
  <IconButton variant={variant} onClick={handler} disabled={disabled} type="button">
    <AddThin />
  </IconButton>
);
